import axios from 'axios';
import type {
  IFindLinkedContactsRequest,
  IFindLinkedContactsResponse,
} from '@bb/contacts';

const findLinkedContacts = async (contactId: string) => {
  const config: IFindLinkedContactsRequest = {
    url: `/contacts/${contactId}/linked`,
    params: { contactId },
    method: 'get',
  };

  const { data } = await axios.request<IFindLinkedContactsResponse>(config);

  return data;
};

export default findLinkedContacts;
